import { i18n } from 'core/i18n';
import React, { useMemo } from 'react';
import { OKButton } from 'components/commons/OKButton/OKButton';

const { formatText } = i18n

export const DocumentationButton = ({ documentsList, onClick }) => {
    const documentationButtonText = useMemo(
        () =>
            documentsList?.some(document => document.isAccepted) &&
            documentsList?.some(document => !document.isAccepted)
                ? formatText('contractsView-dic_buttonReadAllDocuments')
                : formatText('contractsView-dic_buttonReadAllDocuments'),
        [documentsList]
    );

    return (
        <div className="documentation-button">
            <OKButton
                modifier="primary"
                onClick={onClick}
            >
                {documentationButtonText}
            </OKButton>
        </div>
    );
};
